'use strict';
exports.init = function () {
	
		console.log("flexslider called");
		
		$('#homepage-slider.flexslider').flexslider({
			animation: "slide",
			animationLoop: true,
			slideshow: true,
			directionNav: false,
			controlNav: true,
			useCSS: true,
			slideshowSpeed: 5000
		});
		
		$('#whatsnew-slider.flexslider.desktop-tablet').flexslider({
			animation: "slide",
			selector: ".slides > .slide",
			animationLoop: true,
			slideshow: true,
			directionNav: true,
			controlNav: true,
			useCSS: true,
			slideshowSpeed: 5000,
			initDelay: 2000
		});
		
		$('#whatsnew-slider.flexslider.mobile').flexslider({
			animation: "slide",
			selector: ".slides > li",
			animationLoop: true,
			slideshow: true,
			directionNav: true,
			controlNav: true,
			useCSS: true,
			slideshowSpeed: 5000,
			initDelay: 2000
		});
		
};
